import { Component, Input } from '@angular/core';

import { PaymentPromptpayComponent } from '../../payment-promptpay.component';

/**
 * "the_portrait" view of /payment-promptpay.
 *
 * The QR keeps its dark-on-light rendering on a white plate rather than following the
 * mockup's inverted look: PromptPay's code is an Omise bitmap, and inverted QR codes fail to
 * scan on a large share of phone cameras. Everything else follows the mockup.
 */
@Component({
  selector: 'app-payment-promptpay-portrait',
  templateUrl: './payment-promptpay-portrait.component.html',
  styleUrls: ['./payment-promptpay-portrait.component.scss']
})
export class PaymentPromptpayPortraitComponent {

  @Input() host!: PaymentPromptpayComponent;

}
